import { Schema, arrayOf } from 'normalizr';

import { subtitleTracksSchema } from 'state/subtitles/schema/subtitlesSchema';

export const assetSchema = new Schema('assets', { idAttribute: 'id' });
assetSchema.define({ subtitles: arrayOf(subtitleTracksSchema) });
